import { font, oPopupPadding, Popup } from '@approvalmax/ui';
import styled from 'styled-components';

export const DefaultContent = styled(Popup.DefaultContent)`
    position: relative;
    width: 620px;
    max-height: 400px;
`;

export const Content = styled.div`
    ${oPopupPadding()}
`;

export const Description = styled.div`
    ${font(12)}
`;

export const TableContainer = styled.div`
    overflow-y: auto;
    max-height: 140px;
`;

export const BeneficiaryName = styled.div`
    ${font(12, '#a3341a', 'bold')}
`;

export const ButtonContainer = styled.div`
    display: flex;
    justify-content: end;
    margin-top: 30px;
`;
